class HeaderV2Menu extends HTMLElement {
  constructor() {
    super();
    this.detailsElements = this.querySelectorAll('details');
    this.bindEvents();
  }

  bindEvents() {
    this.detailsElements.forEach((details) => {
      const summary = details.querySelector('summary');
      
      // Desktop: Open on hover
      details.addEventListener('mouseenter', () => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          this.closeAllMenus();
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        }
      });

      details.addEventListener('mouseleave', () => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }
      });
      
      // Prevent click if hovering is active (Desktop only)
      summary.addEventListener('click', (e) => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          e.preventDefault();
        }
      });
    });
    
    // Close on escape
    document.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.closeAllMenus();
      }
    });
  }

  closeAllMenus() {
    this.detailsElements.forEach((details) => {
      details.removeAttribute('open');
      details.querySelector('summary').setAttribute('aria-expanded', 'false');
    });
  }
}

customElements.define('header-v2-menu', HeaderV2Menu);